export default __webpack_public_path__ + "assets/webgl/complete-27.54b0f8e6.jpg";